<template>
	<div class="myday-date-nav" @click.stop>
		<v-btn @click="stepDay(-1)" icon variant="tonal" size="small" color="primary">
			<v-icon>chevron_left</v-icon>
		</v-btn>

		<v-menu v-model="menu" v-bind="menuProps" location="bottom center" teleport="false" :close-on-content-click="false" transition="scale-transition" offset-y>
			<template #activator="{ props: activatorProps }">
				<span class="myday-date-nav__label" v-bind="activatorProps">{{ formattedDate }}</span>
			</template>
			<v-date-picker :model-value="modelValue" @update:model-value="onPicked" density="compact" color="primary" show-adjacent-months hide-header>
				<template #actions>
					<v-btn variant="text" color="primary" @click="setToday">{{ t('Today') }}</v-btn>
				</template>
			</v-date-picker>
		</v-menu>

		<v-btn @click="stepDay(1)" icon variant="tonal" size="small" color="primary">
			<v-icon>chevron_right</v-icon>
		</v-btn>
	</div>
</template>

<script setup>
import { ref, computed, inject } from 'vue';
import { addDays, subDays, format } from 'date-fns';
import { fr, enGB, es, pt, nl, de } from 'date-fns/locale';
import { useTranslator } from '@/composables/useTranslator';
import { iframeDataBridge } from '@/iframe/iframeDataBridge';

const props = defineProps({
	modelValue: { type: Date, required: true },
	dateFormat: { type: String, default: 'd MMMM yyyy' },
});
const emit = defineEmits(['update:modelValue']);

const t = useTranslator();
const overlayTarget = inject('overlayTarget', null);
const menu = ref(false);
const menuProps = computed(() => ({
	attach: overlayTarget || undefined,
	scrim: true,
	scrollStrategy: 'close',
}));

const DATE_FNS_LOCALES = { fr, en: enGB, es, pt, nl, de };
const formattedDate = computed(() => {
	const rawLocale = iframeDataBridge.getCurrentUser()?.locale;
	const key = rawLocale ? rawLocale.split('-')[0] : (navigator.language?.split('-')[0] ?? 'fr');
	const locale = DATE_FNS_LOCALES[key] ?? fr;
	return format(new Date(props.modelValue), props.dateFormat, { locale });
});

function stepDay(step) {
	emit('update:modelValue', step > 0 ? addDays(new Date(props.modelValue), 1) : subDays(new Date(props.modelValue), 1));
}

function onPicked(value) {
	emit('update:modelValue', value);
	menu.value = false;
}

function setToday() {
	emit('update:modelValue', new Date());
	menu.value = false;
}
</script>
